import React, { useEffect, useState } from 'react';

import { toast, ToastContainer } from 'react-toastify';

import PageTitle from '../../components/stateless/PageTitle';
import Heading from '../../components/stateless/Heading';
import Description from '../../components/stateless/Description';
import SkeletonLoader from '../../components/stateless/Skeleton';
import BmeLandingForm from '../../components/statefull/BmeLandingForm';

import { getData, postDataFormData } from '../../helpers/postData';
import setErrorHandler from '../../helpers/setErrorHandler';

import './index.scss';

function BecomePartner() {
  const [formFields, setFormFields] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [reset, setReset] = useState(false);
  const [showV2, setShowV2] = useState(false);

  const checkFormValidity = (e) => {
    const res = setErrorHandler(formFields, e);
    setFormFields(res);

    return new Promise((resolve) => {
      resolve(!res.find(item => item.hasError));
    })
  }

  const submitHandler = async (e) => {
    const res = await checkFormValidity(e);

    if (res) {
      let formData = new FormData();

      for (let item in e) {
        console.log(item, e[item]);
        if (item === 'website') {
          e[item] && formData.append(item, e[item]);
        } else {
          formData.append(item, e[item]);
        }
      }

      formData.set('phone[countryCode]', e['phone.countryCode'] || countryList[0].phoneCode[0]);
      formData.set('phone[number]', e['phone.number']);
      formData.set('company[countryCode]', e['company.countryCode']);
      formData.set('company[name]', e['company.name']);

      postDataFormData('/partner-requests', formData, true).then(res => {
        if (res.data) {
          if (res.data.passed) {
            setReset(true);

            setTimeout(() => {
              setReset(false);
            }, 1000);
            setShowV2(false);
            toast('Done');
          } else {
            setShowV2(true);
          }
        }
      })
    }
  };

  useEffect(async () => {
    const res = await getData('/partner-requests/countries');
    const res1 = await getData('/partner-requests/positions');
    const res2 = await getData('/partner-requests/partnership-types');

    setCountryList(res.data);
    setFormFields([
      {
        name: 'Full Name',
        type: 'text',
        slug: 'name',
        validation: {
          required: true,
          min: 5,
          max: 50,
          regex: /[a-zA-Z0-9_s-]+$/,
          error: 'Enter valid name'
        }
      },
      {
        name: 'Email',
        type: 'email',
        slug: 'email',
        validation: {
          required: true,
          regex: /^([a-z0-9_\.-]+)@([\da-z0-9\.-]+)\.([a-z\.]{2,32})$/i,
          error: 'Enter valid E-mail'
        }
      },
      {
        name: 'Position',
        type: 'select',
        slug: 'position',
        list: res1.data,
        validation: {
          required: true,
          error: 'Enter valid input'
        }
      },
      {
        name: 'Phone Number',
        type: 'phone',
        slug: 'phone.number',
        list: res.data,
        validation: {
          required: true,
          regex: /^[0-9]+$/i,
          error: 'Enter valid input',
          min: 5,
          max: 20,
        }
      },
      {
        name: 'Company Name',
        type: 'text',
        slug: 'company.name',
        validation: {
          required: true,
          min: 5,
          max: 50,
          regex: /^(?!.*  )[a-z0-9/_\-\,.""''()/\s/]+$/i,
          error: 'Enter valid input'
        }
      },
      {
        name: 'Country',
        type: 'select',
        slug: 'company.countryCode',
        validation: {
          required: true,
          error: 'Enter valid input'
        },
        list: res.data,
      },
      {
        name: 'Partnership Type',
        type: 'select',
        slug: 'partnershipType',
        validation: {
          required: true,
          error: 'Enter valid input'
        },
        list: res2.data,
      },
      {
        name: 'Website (optional)',
        type: 'text',
        slug: 'website',
        validation: {
          required: false,
          regex: /(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,32}\b([-a-zA-Z0-9@:%_\+.~#()?&//=]*)/,
          error: 'Enter valid site'
        }
      },
      {
        name: 'Pricing (optional)',
        type: 'file',
        slug: 'priceSheet',
        validation: {
          required: false,
        }
      },
      {
        name: 'Presentation (optional)',
        type: 'file',
        slug: 'presentation',
        validation: {
          required: false,
        }
      },
      {
        name: 'Type a request summary',
        type: 'textarea',
        slug: 'requestSummary',
        validation: {
          min: 5,
          max: 1024,
          required: true,
          regex: /[a-zA-Z0-9,:._s-]+$/,
          error: 'Enter valid input'
        }
      },
    ]);
  }, [getData])

  return (
    <>
      <PageTitle
        heading="Start Partnership"
        description="If your business or operation is or aims to be involved in iGaming one way or another, BetConstruct is always happy to present you with compelling partnership options."
      />
      <div className="page-content">
        {formFields.length ?
          <BmeLandingForm showV2={showV2} formFields={formFields} submitText="Send" reset={reset}
                          onSubmit={submitHandler}/>
          : <SkeletonLoader />
        }
      </div>
      <div className="contact-info-block">
        <div className="container-layout">
          <div className="product-container">
            <div className="product-container-inner">
              <Heading size="xs" color="primary" content="Product Provider" />
              <Description
                  size="small"
                  color="light"
                  content="If you develop games, or build sportsbooks, or provide feeds, or basically offer any iGaming-related products and tools, we’ll be delighted to discuss our Product Provider partnership option with you." />
            </div>
            <div className="product-container-inner">
              <Heading size="xs" color="primary" content="Service Provider" />
              <Description
                  size="small"
                  color="light"
                  content="In case you offer services such as translation, marketing, design, event management, CRM, SMM, risk management that can be efficiently used in the area of iGaming, we’ll be happy to talk over the Service Provider partnership option with you." />
            </div>
            <div className="product-container-inner">
              <Heading size="xs" color="primary" content="Business Partner" />
              <Description
                  size="small"
                  color="light"
                  content="In case you reckon we can end up with a mutually beneficial cooperation - even if you don’t offer any iGaming-focused services and don’t provide any relevant products or tools - we could consider seeing you as our potential Business Partner. Got any collaboration ideas up your sleeve? Get in touch." />
            </div>
          </div>
        </div>
      </div>
      <ToastContainer hideProgressBar />
    </>
  )
};

export default BecomePartner;
